import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.parse-int.js";

/**
 * 版本号比较
 * @param {string} v1 版本号1，形如"2.2.3"
 * @param {string} v2 版本号2
 * @return {number} 比较结果，[-1 小于 | 0 等于 | 1 大于]
 */
export default function compareVersion(v1, v2) {
  var seq1 = v1.split(".").map(function (subVersion) {
    return parseInt(subVersion);
  });
  var seq2 = v2.split(".").map(function (subVersion) {
    return parseInt(subVersion);
  });
  var len1 = seq1.length,
      len2 = seq2.length,
      commonLen = Math.min(len1, len2);

  for (var i = 0; i < commonLen; ++i) {
    if (seq1[i] != seq2[i]) return seq1[i] < seq2[i] ? -1 : 1;
  }

  return len1 == len2 ? 0 : len1 < len2 ? -1 : 1;
}